export const environment = {
	production: true,
	embedSourceWhitelisted: false,
	forceApp: false,
	inDev: false,
	plugins: [],
	apiUrl: 'https://dancebug.com/rest/api',
	dancebugUrl: 'https://dancebug.com',
	reCaptchaSite: '6LfmJdkaAAAAAEXf-lNcS9W2sqzKRSrY8l84r-Y3',
	firebase: {
		firebaseConfig: {
			apiKey: 'AIzaSyDaX0kcxitsbjMCt3mYwj9nON9KVn00n0I',
			authDomain: 'dancebug-173600.firebaseapp.com',
			databaseURL: 'https://dancebug-173600.firebaseio.com',
			projectId: 'dancebug-173600',
			storageBucket: 'dancebug-173600.firebasestorage.app',
			messagingSenderId: '890117746971',
			appId: '1:890117746971:web:ef8bb876b9463d6bbb63be',
			measurementId: 'G-08VZSR7PX7',
		},
		vapidKey: 'BLsdToWoFCNlDIlsRXsSDGo79thfEIRWlFHlbbETF1t2qa89oNvaV8A6fBQtFlrKrqJruaN-21xFiz6QSsH0VgM',
	},
	mediaOptions: {
		itemsPerPage: 5,
		itemsPerPageOld: 40,
	},
	appRatingSurveyId: 2,
};
